<template>
  <div>
    <div class="primary--text">{{ $t('message_audience') }}</div>
    <apexchart
      :key="chartKey"
      type="bar"
      height="350"
      :options="chartOptions"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import cloneDeep from 'lodash/cloneDeep'

export default {
  components: {
    apexchart: VueApexCharts
  },
  props: ['value'],
  data() {
    return {
      chartKey: 0,
      data: null,
      series: [],
      chartOptions: {
        chart: {
          type: 'bar',
          height: 350,
          stacked: true,
          toolbar: {
            show: true
          },
          zoom: {
            enabled: true
          }
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                position: 'bottom',
                offsetX: -10,
                offsetY: 0
              }
            }
          }
        ],
        plotOptions: {
          bar: {
            horizontal: false,
            dataLabels: {
              total: {
                enabled: true,
                style: {
                  fontSize: '13px',
                  fontWeight: 900
                }
              }
            }
          }
        },
        xaxis: {
          categories: []
        },
        legend: {
          position: 'right',
          offsetY: 40
        },
        fill: {
          opacity: 1
        }
      }
    }
  },
  computed: {
    getTimeCategories() {
      return [
        '00:00',
        '01:00',
        '02:00',
        '03:00',
        '04:00',
        '05:00',
        '06:00',
        '07:00',
        '08:00',
        '09:00',
        '10:00',
        '11:00',
        '12:00',
        '13:00',
        '14:00',
        '15:00',
        '16:00',
        '17:00',
        '18:00',
        '19:00',
        '20:00',
        '21:00',
        '22:00',
        '23:00'
      ]
    }
  },
  watch: {
    value: {
      handler() {
        this.data = this.value
        this.transformDataRenderChart()
      },
      deep: true
    }
  },
  mounted() {
    this.data = this.value
    this.chartOptions.xaxis.categories = this.getTimeCategories
    this.transformDataRenderChart()
  },
  methods: {
    getGroupAudience(dataset) {
      const rearrageDataset = []
      Object.keys(dataset).forEach((label) => {
        rearrageDataset.push({
          label: label,
          ...dataset[label]
        })
      })

      const labels = rearrageDataset.reduce((prev, curr) => {
        let tempGroupAudience = Object.entries(curr.group_audience)
        const groupAudiences = tempGroupAudience.reduce((prev2, curr2) => {
          if (!Object.hasOwn(prev2, curr2[0])) {
            prev2[curr2[0]] = curr2[1]
          }
          return prev2
        }, {})

        Object.keys(groupAudiences).forEach((groupKey) => {
          const groupCount = groupAudiences[groupKey]
          const index = prev.findIndex((el) => el.label == groupKey)
          if (index != -1) {
            prev[index].count = prev[index].count + groupCount
          } else {
            prev.push({
              label: groupKey,
              count: groupCount
            })
          }
        })

        return prev
      }, [])

      return labels
    },
    transformDataRenderChart() {
      const vm = this
      try {
        const tempData = cloneDeep(vm.data)
        if (tempData) {
          const groupAudiences = vm.getGroupAudience(tempData)
          const chartSeries = groupAudiences.map((el) => {
            const processedData = []

            Object.keys(tempData).forEach((label) => {
              if (Object.hasOwn(tempData, label)) {
                const data = {
                  label: label,
                  ...tempData[label]
                }
                if (Object.hasOwn(data.group_audience, el.label)) {
                  processedData.push(data.group_audience[el.label])
                } else {
                  processedData.push(0)
                }
              }
            })

            return {
              name: el.label,
              data: processedData
            }
          })

          vm.transformExportData(groupAudiences, tempData)

          vm.series = chartSeries
        } else {
          vm.series = []
        }
        vm.chartKey += 1
      } catch (error) {
        console.error(error)
      }
    },
    transformExportData(groupAudiences, dataset) {
      const header = ['เวลา', 'ผู้ใช้ตามเวลาที่ระบุ']

      const mapGroup = groupAudiences.map((group) => group.label)
      header.push(...mapGroup)

      const tempCategories = this.getTimeCategories

      const processedData = []
      Object.keys(dataset).forEach((date, index) => {
        const data = [tempCategories[index], dataset[date].total_messages]
        const tempDataGroup = dataset[date].group_audience

        groupAudiences.forEach((group) => {
          if (Object.keys(tempDataGroup).includes(group.label)) {
            data.push(tempDataGroup[group.label])
          } else {
            data.push(0)
          }
        })
        processedData.push(data)
      })

      const exportData = {
        header: header,
        data: processedData
      }
      this.$emit('exportData', exportData)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/Beacon/Analytics/Charts/MetricMessagesGroupByTimeChart.vue